/**
 * Created by m.igrachev on 7/20/2017.
 */
import Validator from "validator";
import unifyDecimalString from "../localization/unifyDecimalString";

//Function to validate whether a value is valid decimal or can become a valid decimal!
export default function(toValidate, options = {}) {
    //do not need to check undefined and empty string
    if (!toValidate || toValidate === "") {
        return true;
    }
    let validationType = options.validationType || "hard";
    let unifiedValue = toValidate.toString();
    if (options.locale) {
        unifiedValue = unifyDecimalString(toValidate, options) || toValidate.toString();
    }
    if (validationType === "soft") {
        //Note Soft validation is trying to consider whether the value can become the starting part of valid decimal.
        //A valid decimal can start with or '-' or ''
        //In case validation is smart it will also consider decimal starting with '.'
        if (
            (options.smart && unifiedValue === ".") ||
            unifiedValue === "-" ||
            unifiedValue === ""
        ) {
            return true;
        }
    }
    if (!options.smart) {
        //npm validator is considering 123. as valid decimal. We want that only for "smart" validation!
        //Ends with '.' or ',' are not allowed!
        let endCharacter = toValidate[toValidate.length - 1];
        if (endCharacter === "." || endCharacter === ",") {
            return false;
        }
        //Starts with '.' or ',' are not allowed!
        let startCharacter = (toValidate && toValidate[0]) || "";
        if (startCharacter === "." || startCharacter === ",") {
            return false;
        }
    }
    //Otherwise a valid decimal can start with a valid decimal => continue with the code

    //Note - Hard validation simple checks if the passed value can be considered decimal.
    let toValidateTokens = unifiedValue.split(".");
    let tokensLength = toValidateTokens.length;
    if (tokensLength === 2 && toValidateTokens[1] === "") {
        return Validator.isDecimal(toValidateTokens[0]);
    }
    return Validator.isDecimal(unifiedValue);
}
